import SpecProcessor, { type Spec, type Data } from './specProcessor';

export default class ExternalSpecProcessor extends SpecProcessor {
  static preprocessing(data: Data, spec: Spec): boolean {
    return (
      ExternalSpecProcessor.isDataValid(data, spec) &&
      (ExternalSpecProcessor.isEncodingValid(data, spec) as boolean)
    );
  }
}
